import React from 'react'

export const PdfSenderMessages = ({ profileData, time, pdf }) => {
	return (
		<>
			<div className="flex items-start gap-3 p-1 pb-0 justify-end">
				<div className='flex flex-col'>
					<div className='rounded-md p-2' style={{ background: '#efefef' }}>
						<div className="relative inline-block bg-white rounded-sm shadow">
							<div className="flex gap-3 items-center border-b border-inherit pt-2 pb-2 px-3">
								<a href={pdf?.url} target='_blank' className='btnnn' rel='noopener noreferrer'>
									<svg width="50" height="40" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clipPath="url(#clip0_57_2-751433)">
											<path d="M19.9021 6.47316L13.7129 0.10102C13.6501 0.0365918 13.5655 0 13.477 0H6.46633C4.8347 0 3.50728 1.36692 3.50728 3.04655V9.07545H0.910023C0.408235 9.07545 0 9.49569 0 10.0122V15.3971C0 15.9136 0.408235 16.3339 0.910023 16.3339H3.50707V18.9537C3.50728 20.6331 4.83448 22 6.46633 22H17.041C18.6726 22 20 20.6331 20 18.9534V6.71651C19.9998 6.62537 19.9647 6.53759 19.9021 6.47316ZM3.00179 14.5478V10.8624C3.00179 10.6725 3.15117 10.5187 3.33566 10.5187H4.41142C5.1882 10.5187 5.82061 11.1697 5.82061 11.9693V12.0158C5.82061 12.8159 5.1882 13.4665 4.41142 13.4665H3.66931V14.5481C3.66931 14.738 3.51993 14.8918 3.33588 14.8918C3.15117 14.8918 3.00179 14.7378 3.00179 14.5478ZM6.59761 14.5478V10.8624C6.59761 10.6725 6.74699 10.5187 6.93104 10.5187H8.0068C8.78402 10.5187 9.416 11.1697 9.416 11.9693V13.4411C9.416 14.2407 8.78402 14.8918 8.0068 14.8918H6.93104C6.74721 14.8918 6.59761 14.7378 6.59761 14.5478ZM12.4782 12.1584C12.6627 12.1584 12.8121 12.3121 12.8121 12.5016C12.8121 12.6915 12.6627 12.8453 12.4782 12.8453H10.927V14.5478C10.927 14.7378 10.7777 14.8915 10.5936 14.8915C10.4091 14.8915 10.2597 14.7378 10.2597 14.5478V10.8624C10.2597 10.6725 10.4091 10.5187 10.5936 10.5187H12.7445C12.9285 10.5187 13.0779 10.6725 13.0779 10.8624C13.0779 11.0519 12.9285 11.2056 12.7445 11.2056H10.927V12.1581L12.4782 12.1584ZM19.3325 18.9534C19.3325 20.2546 18.3045 21.3128 17.041 21.3128H6.46633C5.20281 21.3128 4.17481 20.2546 4.17481 18.9534V16.3337H15.169C15.6708 16.3337 16.079 15.9134 16.079 15.3969V10.0122C16.079 9.49569 15.6708 9.07545 15.169 9.07545H4.17459V3.04655C4.17459 1.74541 5.20259 0.687163 6.46611 0.687163H13.1429V6.02822C13.1429 6.59708 13.5921 7.05998 14.1438 7.05998H19.3323L19.3325 18.9534ZM4.41142 12.7793H3.66931V11.2059H4.41142C4.82053 11.2059 5.15309 11.5484 5.15309 11.9693V12.0158C5.15309 12.437 4.82031 12.7793 4.41142 12.7793ZM8.0068 14.2046H7.26513V11.2059H8.0068C8.41591 11.2059 8.74847 11.5484 8.74847 11.9693V13.4411C8.74869 13.8622 8.41591 14.2046 8.0068 14.2046Z" fill="#FA3737" />
										</g>
										<defs>
											<clipPath id="clip0_57_2-751433">
												<rect width="20" height="22" fill="white" />
											</clipPath>
										</defs>
									</svg>
									<p className="rubik-400 fs-14">{pdf?.name}</p>
									<p className="fs-10 rubik-400 ot_pdfColor">{pdf?.size} | PDF Document</p>
								</a>
							</div>
						</div>
					</div>
					<span className="fs-10 grey-color rubik-400 text-right w-full block pt-2">{time}</span>
				</div>
				{/* <img src={profileData?.photo} className="h-8 w-8 rounded-full text-right" alt="" /> */}
			</div>
		</>
	)
}

export const PDFReceiverMessages = ({ chatUser, time, pdf, data, selectedData }) => {
	return (<>
		<div className="flex items-start gap-3 p-1 pb-0 ml-2">
			<div className='flex flex-col'>
				{/* {selectedData?.group_type === 'one_to_many' &&
					<p className='rubik-500 fs-12 dark-color ml-1'>{data.user_name}</p>} */}
				<div className="rounded-md p-2" style={{ background: 'rgb(206 240 255)' }}>
					<div className="relative inline-block bg-white rounded-sm shadow">
						<div className="flex gap-3 items-center border-b border-inherit pt-2 pb-2 px-3">
							<a target='_blank' href={pdf?.url} className='btnnn' rel='noopener noreferrer'>
								<svg width="50" height="40" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_57_2-751433)">
										<path d="M19.9021 6.47316L13.7129 0.10102C13.6501 0.0365918 13.5655 0 13.477 0H6.46633C4.8347 0 3.50728 1.36692 3.50728 3.04655V9.07545H0.910023C0.408235 9.07545 0 9.49569 0 10.0122V15.3971C0 15.9136 0.408235 16.3339 0.910023 16.3339H3.50707V18.9537C3.50728 20.6331 4.83448 22 6.46633 22H17.041C18.6726 22 20 20.6331 20 18.9534V6.71651C19.9998 6.62537 19.9647 6.53759 19.9021 6.47316ZM3.00179 14.5478V10.8624C3.00179 10.6725 3.15117 10.5187 3.33566 10.5187H4.41142C5.1882 10.5187 5.82061 11.1697 5.82061 11.9693V12.0158C5.82061 12.8159 5.1882 13.4665 4.41142 13.4665H3.66931V14.5481C3.66931 14.738 3.51993 14.8918 3.33588 14.8918C3.15117 14.8918 3.00179 14.7378 3.00179 14.5478ZM6.59761 14.5478V10.8624C6.59761 10.6725 6.74699 10.5187 6.93104 10.5187H8.0068C8.78402 10.5187 9.416 11.1697 9.416 11.9693V13.4411C9.416 14.2407 8.78402 14.8918 8.0068 14.8918H6.93104C6.74721 14.8918 6.59761 14.7378 6.59761 14.5478ZM12.4782 12.1584C12.6627 12.1584 12.8121 12.3121 12.8121 12.5016C12.8121 12.6915 12.6627 12.8453 12.4782 12.8453H10.927V14.5478C10.927 14.7378 10.7777 14.8915 10.5936 14.8915C10.4091 14.8915 10.2597 14.7378 10.2597 14.5478V10.8624C10.2597 10.6725 10.4091 10.5187 10.5936 10.5187H12.7445C12.9285 10.5187 13.0779 10.6725 13.0779 10.8624C13.0779 11.0519 12.9285 11.2056 12.7445 11.2056H10.927V12.1581L12.4782 12.1584ZM19.3325 18.9534C19.3325 20.2546 18.3045 21.3128 17.041 21.3128H6.46633C5.20281 21.3128 4.17481 20.2546 4.17481 18.9534V16.3337H15.169C15.6708 16.3337 16.079 15.9134 16.079 15.3969V10.0122C16.079 9.49569 15.6708 9.07545 15.169 9.07545H4.17459V3.04655C4.17459 1.74541 5.20259 0.687163 6.46611 0.687163H13.1429V6.02822C13.1429 6.59708 13.5921 7.05998 14.1438 7.05998H19.3323L19.3325 18.9534ZM4.41142 12.7793H3.66931V11.2059H4.41142C4.82053 11.2059 5.15309 11.5484 5.15309 11.9693V12.0158C5.15309 12.437 4.82031 12.7793 4.41142 12.7793ZM8.0068 14.2046H7.26513V11.2059H8.0068C8.41591 11.2059 8.74847 11.5484 8.74847 11.9693V13.4411C8.74869 13.8622 8.41591 14.2046 8.0068 14.2046Z" fill="#FA3737" />
									</g>
									<defs>
										<clipPath id="clip0_57_2-751433">
											<rect width="20" height="22" fill="white" />
										</clipPath>
									</defs>
								</svg>
								<p className="rubik-400 fs-14">{pdf?.name}</p>
								<p className="fs-10 rubik-400 ot_pdfColor">{pdf?.size} | PDF Document</p>
							</a>
						</div>

					</div>
				</div>
				<span className="fs-10 grey-color rubik-400 text-left w-full block pt-2">{time}</span>
			</div>
		</div>
	</>)
}

export const SenderImageMessage = ({ profileData, image, time, openOverlay }) => {
	return (<>
		<div className="flex items-start justify-end gap-3 p-1 btnnn">
			<div className="rounded-md">
				<div className="ot_downloadImgBtn relative rounded-md inline-block" style={{ border: '1px solid #e1e1e1' }}>
					<button 
					// onClick={() => openOverlay(image)} 
					>
						<img src={image} className="w-32 h-40 rounded-md object-cover" alt="" />
					</button>
				</div>
				<span className="fs-10 grey-color rubik-400 w-full text-right block">{time}</span>
			</div>
			{/* <img src={profileData?.photo} className="h-8 w-8 rounded-full" alt="" style={{ border: '1px solid #e1e1e1' }} /> */}
		</div>

	</>)
}

export const RecevicerImageMessage = ({ chatUser, openOverlay, time, image, data, selectedData }) => {
	return (
		<>
			<div className="flex items-start gap-3 p-1 btnnn ml-2">
				{/* <img src={data?.profile_image} className="h-8 w-8 rounded-full" alt="" style={{ border: '1px solid #e1e1e1' }} /> */}
				<div className="rounded-lg">{selectedData?.group_type === 'one_to_many' &&
					<p className='rubik-500 fs-12 dark-color ml-1'>{data.user_name}</p>}
					<div className="ot_downloadImgBtn relative rounded-md inline-block" style={{ border: '1px solid #e1e1e1' }}>
						<button 
						// onClick={() => openOverlay(image)}
							>
							<img src={image} className="w-32 h-40 rounded-md object-cover" alt="" />
						</button>
					</div>
					<span className="fs-10 grey-color rubik-400 text-left w-full block pt-0">{time}</span>
				</div>
			</div>
		</>
	)
}

export const SenderTextMessages = ({ profileData, textMessage, time }) => {
	return (<>
		<div className={'flex items-start gap-2 p-1 pb-0 justify-end mb-2'}>
			<div className='flex flex-col items-end'>
				<div style={{ background: '#efefef' }} className={`rounded-l-md rounded-b-md  ot_chatLeftBg p-2 ${textMessage?.length > 30 ? 'w-64' : ''}`}>
					<p className="rubik-400 fs-14 text-gray-900 break-all">{textMessage}</p>
				</div>
				<span className="fs-10 grey-color rubik-400 block">{time}</span>
			</div>
			{/* <img src={profileData?.photo} className="h-8 w-8 rounded-full" alt="" /> */}
		</div>
	</>)
}

export const ReceiverTextMessages = ({ chatUser, textMessage, time, data, selectedData }) => {
	return (<>
		<div className="flex items-start gap-2 p-1 pb-0 mr-4 mb-2 ml-2" style={{ marginTop: '2px' }}>
			{/* <img src={data?.profile_image} className="h-8 w-8 rounded-full" alt="" style={{ border: '1px solid #e1e1e1' }} /> */}
			<div className='flex flex-col items-start'>
				{selectedData?.group_type === 'one_to_many' &&
					<p className='rubik-500 fs-12 dark-color'>{data.user_name}</p>}

				<div style={{ background: 'rgb(206 240 255)' }} className={`rounded-r-md rounded-b-md  ot_chatLeftBg p-2  ${textMessage?.length > 30 ? 'w-64' : ''}`}>

					<p className="rubik-400 fs-14 text-gray-900">{textMessage}</p>
				</div>
				<span className="fs-10 grey-color text-right rubik-400 block">{time}</span>
			</div>
		</div>
	</>)
}